import { purposesChanged } from "../../actions/filters";
import makeGroupedMultiSelect from "../../../../shared/make_grouped_multi_select";

const valuesSelector = (state) => state.filters.purposes.selectedValues;
const optionsSelector = (state) => state.filters.purposes.options;

export default makeGroupedMultiSelect(purposesChanged, "Applications", valuesSelector, optionsSelector, { clearable: true, placeholder: "Filter by application" }, { "col-md-3": true });
